enum ExecutionTypeEnum {
    ActiveHttpRequest = 0,
    ReactiveHttpRequest = 1,
    Executable = 2
}

export default ExecutionTypeEnum;
